import React, { useEffect, useState, useCallback } from 'react';
import {
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Table,
  TablePagination,
  Box
} from '@mui/material';
import { CommanTableContain, PaginationContain } from "../../style/Admin/UsersStyles";
import { getAllUsers } from '../../services/userServices';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DashboardHeader from "../../components/Common/DashboardHeader";

const UserList = () => {
  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalData, setTotalData] = useState(0);

  const staticHeaders = [
    { id: "User ID", label: "User ID" },
    { id: "Name", label: "Name" },
    { id: "Phone", label: "Phone", mediaModal: true },
    { id: "Email", label: "Email" },
    { id: "Status", label: "Status" },
  ];

  const userListLoad = useCallback(async () => {
    try {
      const payload = {
        page: page,
        offset: rowsPerPage,
      };
      const response = await getAllUsers(payload);
      if (response.success) {
        const fetchedUsers = response?.data?.usersData || [];
        setUsers(fetchedUsers);
        setTotalData(response?.data?.totalData ?? 0);
        if (fetchedUsers.length === 0) {
          toast.info("No users are present to display.", { toastId: "no-users" });
        }
      } else {
        setUsers([]);
        setTotalData(0);
        toast.info("No users are present to display.", { toastId: "no-users" });
      }
    } catch (error) {
      console.error("Error on loading user data: ", error);
      setUsers([]);
      setTotalData(0);
      toast.info("No users are present to display.", { toastId: "no-users" });
    }
  },[page, rowsPerPage]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    userListLoad();
  }, [userListLoad]);

  return (
    <Box>
      <DashboardHeader title="User List" />
      <CommanTableContain>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>S. no.</TableCell>
              {staticHeaders.map((header) => (
                <TableCell key={header.id}>{header.label}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map((user, rowIndex) => (
              <TableRow key={user.id || rowIndex}>
                <TableCell>{rowsPerPage * page + rowIndex + 1}</TableCell>
                <TableCell>{user.userId}</TableCell>
                <TableCell>{user.name}</TableCell>
                <TableCell>{user.phoneNo}</TableCell>
                <TableCell>{user.emailId}</TableCell>
                <TableCell className={`Form_${user.status?.toLowerCase()}`}>
                  {user.status}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CommanTableContain>
      <PaginationContain>
        <TablePagination
          component="div"
          count={totalData}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </PaginationContain>
      <ToastContainer position="top-right" autoClose={3000} />
    </Box>
  );
};

export default UserList;